import * as types from './types';

const unSelectedFilter = filter => ({ type: types.UNSELECTED_MULTIOPTIONS, payload: filter });

const removeAllFilters = () => ({ type: types.REMOVE_ALL_FILTERS });

const selectedFilter = filters => ({ type: types.SELECTED_MULTIOPTIONS, payload: filters });

const checkboxOption = option => ({ type: types.CHECKBOX_SELECT, payload: option });

const selectedOptions = option => ({ type: types.SELECTED_OPTIONS, payload: option });

const showReportModal = show => ({ type: types.SHOW_REPORT_MODAL, payload: show });

const addTextSearch = filter => ({ type: types.ADD_TEXT_SEARCH, payload: filter });

const addFeedback = filter => ({ type: types.ADD_FEEDBACK, payload: filter });

const removeTextSearch = filter => ({ type: types.REMOVE_TEXT_SEARCH, payload: filter });

const sortOption = filter => ({ type: types.SORT_TABLE, payload: filter });

export {
  removeAllFilters,
  selectedFilter,
  unSelectedFilter,
  checkboxOption,
  selectedOptions,
  showReportModal,
  addTextSearch,
  removeTextSearch,
  sortOption,
  addFeedback
};
